module.exports = {
	data() {
		return {
			errors: {},
			maps: {
				location: null,
				address: '',
				map: null,
				bounds: null,
				geocoder: null,
				autocomplete: null,
				// directionsService: null,
				infowindow: null,
				markers: [], // Only filtered/visible markers (within bounds)
				allMarkers: [], // All markers for all posts
				// directionsRenderers: [],
				icons: {
					default: null
				},
				loaded: false
			},
			selectedRadius: 100,
			radiusOptions: [25, 50, 100],
            updatingMap: false,
            gettingLocation: false,
            servicefinder: null,
            fitMapToBounds: true
		}
	},

	watch: {
		mobileFilterActive(val) {
			if (val) {
				let props = Object.keys(this.temp);

				for (let i=0; i<props.length; i++) {
					Vue.set(this.temp, props[i], this.query[props[i]]);
				}
			}
		}
	},

	computed: {
		placeIds() {
			return this.results.posts.map((place) => { return place.meta.place_id });
		}
	},

	created() {
		//
	},

	methods: {
		/**
		 * Returns a promise to GET a request (for public routes)
		 *
		 * @param  string  url  The URL to get
		 */
		getData(url = '') {
			
			return fetch(url, {
				
				headers: {
					'Accept': 'application/json'
				},
				credentials: 'same-origin'
			})
			.then(this.handleCommonResponseErrors)
			.then(response => response.json())
			.catch(error => console.log(error))
		},

		/**
		 * Returns a promise to POST a request
		 *
		 * @param  string  url     The URL to post
		 * @param  JSON    data    The JSON data to include
		 * @param  string  method  Type of request
		 */
		postJson(url = '', data = {}, method = 'POST') {
			return fetch(url, {
				method: method,
				body: JSON.stringify(data),
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json; charset=utf-8'
				},
				credentials: 'same-origin'
			})
			.then(response => response.json())
			.then(this.handleCommonResponseErrors)
			.catch(error => console.log(error));
		},

		/**
		 * Handle responses when the user is no longer authorized (session expired)
		 */
		handleCommonResponseErrors(response) {
			return response;
		},

		initGoogle() {

			return $.getScript(servicefinder.apiUrl)
				.done(() => {

				this.maps.geocoder = new google.maps.Geocoder();

				const addressField = document.getElementById('address');
				this.pacSelectFirst(addressField);

				this.maps.autocomplete = new google.maps.places.Autocomplete(addressField, {
					componentRestrictions: { country: 'ca' },
					fields: ['formatted_address', 'geometry', 'place_id']
				});

				this.maps.autocomplete.addListener('place_changed', () => {
					const place = this.maps.autocomplete.getPlace();
					if (place?.geometry) {
						this.maps.address = place.formatted_address;
						this.query.lat = place.geometry.location.lat();
						this.query.lng = place.geometry.location.lng();
					}
				});

				this.maps.infowindow = new google.maps.InfoWindow({ content: '' });
				this.maps.infowindow.marker = null;

				this.maps.icons.default = {
					url: servicefinder.pinUrl,
					size: new google.maps.Size(23, 30),
					scaledSize: new google.maps.Size(23, 30)
				};

				this.maps.loaded = true;
				})
				.fail((jqxhr, settings, exception) => {
					console.error('❌ Failed to load Google Maps API script:', exception);
					alert('There was an error loading the map. Please try again later.');
				});
		},

		initMap() {
			let self = this;

			//Don't draw the map if it already is drawn
			if (this.maps.map || !this.maps.loaded) return;

			//Default values
			let zoom = this.maps.location ? 10 : 4;
			let lat = this.maps.location && this.maps.location.lat ? this.maps.location.lat : 60;
			let lng = this.maps.location && this.maps.location.lng ? this.maps.location.lng : -105;

			//Draw the map, centered on current location
			this.maps.map = new google.maps.Map(document.getElementById('map'), {
                zoom: zoom,
                center: {
                    lat: lat,
                    lng: lng
                },
                mapTypeControl: false,
                streetViewControl: false
            });

			// Force a resize event after creating the map to ensure redraw
			google.maps.event.trigger(this.maps.map, 'resize');

            //Add listener for map bounds changing
            google.maps.event.addListener(this.maps.map, 'center_changed', function() {
            	self.handleMapMovement();
            });

            google.maps.event.addListener(this.maps.map, 'zoom_changed', function() {
            	self.handleMapMovement();
            });
			
			this.clusterer = new MarkerClusterer(
				this.maps.map,
				[],
				{
					renderer: {
						render({ count, position }, stats) {
							const svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240"><circle cx="120" cy="120" opacity="1" r="70" fill="#FFFFFF" stroke="#E72C75" stroke-width="5"/></svg>';
							const svgBase64 = window.btoa(svg);
							return new google.maps.Marker({
								position,
								icon: {
									url: `data:image/svg+xml;base64,${svgBase64}`,
									scaledSize: new google.maps.Size(56, 56),
									size: new google.maps.Size(56, 56),
									labelOrigin: new google.maps.Point(28, 28)
								},
								label: {
									text: String(count),
									color: "#E72C75",
									fontSize: "12px",
									fontWeight: "900",
									fontFamily: "GreycliffCF, Helvetica, Arial, Sans-Serif"
								},
								zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
							});
						}
					}
				}
			);
		},

		handleMapMovement() {
			if (this.updatingMap) return;

			//Show the seach area button
			this.showSearchHere = true;
		},

		searchHere() {
			//Hide the search here
			this.showSearchHere = false;

			//We don't want to move the map bounds for this search
			this.fitMapToBounds = false;

			let center = this.maps.map.getCenter();
			let zoom = this.maps.map.getZoom();

			this.navigateToLocation(center.lat(), center.lng(), '', zoom);
		},

		updateMap() {
			//Set flag
			this.updatingMap = true;

			let self = this;

			this.clearMarkers();

			// Always clear allMarkers and markers arrays
			this.maps.allMarkers = [];
			this.maps.markers = [];

			if (this.results.posts.length) {
				this.maps.bounds = new google.maps.LatLngBounds();

				this.allPosts.forEach((place) => {
					let marker = new google.maps.Marker({
						map: this.maps.map,
						position: {lat: parseFloat(place.meta.lat), lng: parseFloat(place.meta.lng)},
						icon: {
							path: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z M12 11.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z",
							fillColor: "#FFD200",
							fillOpacity: 1,
							strokeColor: "#FFD200",
							strokeWeight: 0.5,
							scale: 1.5,
							anchor: new google.maps.Point(12, 24)
						}
					});

					marker.refersTo = place;
					this.maps.allMarkers.push(marker);
					
					place.marker = marker;

					let self = this;
					marker.addListener('click', function() {
						console.log('Marker clicked:', this);
						self.showInfoWindow(this);
					});
				});
				
				if (this.clusterer) {
					this.clusterer.clearMarkers();
					this.clusterer.addMarkers(this.maps.allMarkers);
				}

				// Now filter visible markers (within current search bounds)
				// For the initial load, assume all markers are visible unless bounds are defined
				// We use fitMapToBounds to control zooming/centering
				let visibleMarkers = [];
				let bounds = new google.maps.LatLngBounds();

				this.maps.allMarkers.forEach((marker) => {
					// If fitMapToBounds is true, filter markers within search bounds
					// Otherwise, show all markers (e.g., after "search here")
					if (this.fitMapToBounds) {
						// If there is a query radius and a center, check distance
						if (this.query.lat && this.query.lng && this.selectedRadius) {
							const markerLat = marker.getPosition().lat();
							const markerLng = marker.getPosition().lng();
							const centerLat = parseFloat(this.query.lat);
							const centerLng = parseFloat(this.query.lng);
							const radiusMeters = this.selectedRadius * 1000;
							const dLat = (markerLat - centerLat) * Math.PI / 180;
							const dLng = (markerLng - centerLng) * Math.PI / 180;
							const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
								Math.cos(centerLat * Math.PI / 180) * Math.cos(markerLat * Math.PI / 180) *
								Math.sin(dLng/2) * Math.sin(dLng/2);
							const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
							const d = 6371000 * c; // meters
							if (d <= radiusMeters) {
								visibleMarkers.push(marker);
								bounds.extend(marker.getPosition());
							}
						} else {
							// No radius or center, treat as visible
							visibleMarkers.push(marker);
							bounds.extend(marker.getPosition());
						}
					} else {
						// fitMapToBounds false: all markers are visible
						visibleMarkers.push(marker);
						bounds.extend(marker.getPosition());
					}
				});

				this.maps.markers = visibleMarkers;
				this.maps.bounds = bounds;

				//Fit map to new bounds, if needed
				if (this.fitMapToBounds) {
					if (this.maps.markers.length === 1) {
						this.maps.map.setZoom(10);
						this.maps.map.setCenter(this.maps.markers[0].getPosition());
					} else if (this.maps.markers.length > 1) {
						this.maps.map.fitBounds(this.maps.bounds);
					}
				}
			} else {
				// If no posts, still clear clusters
				if (this.clusterer) {
					this.clusterer.clearMarkers();
				}
			}

			this.updatingMap = false;
		},

		updateMapCenter() {
			
			if (!this.maps.map) return;

			//Flag
			this.updatingMap = true;

			//Center
			this.maps.map.setCenter({lat: parseFloat(this.query.lat), lng: parseFloat(this.query.lng)});

			//Unflag
			this.updatingMap = false;
		},

		updateBounds() {
			//Adjust map bounds
			window.setTimeout(() => {
				if (this.maps.map) {
					this.maps.map.fitBounds(this.maps.bounds);
				}
			}, 400);
		},

		clearMarkers() {
			// Remove all markers from map (both visible and all)
			if (this.maps.allMarkers && this.maps.allMarkers.length) {
				this.maps.allMarkers.forEach((marker) => {
					marker.setMap(null);
				});
			}
			this.maps.markers = [];
			this.maps.allMarkers = [];
		},

		findUserLocation() {
			this.gettingLocation = true;
			this.fitMapToBounds = true;

			if (window.location.protocol == 'https:') {
				this.requestUserLocation(); //Needs HTTPS so not working locally
			}
			else {
				this.locateIP();
			}
		},

		requestUserLocation() {
			this.gettingLocation = true;

			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					((position) => {
						const lat = position.coords.latitude;
						const lng = position.coords.longitude;
						
						this.maps.location = { lat, lng };
						this.query.lat = lat;
						this.query.lng = lng;
						this.geocodeLocation();
						this.initMap();
						this.navigateToLocation(lat, lng, '', 10);
					}),
					((error) => {
						this.locateIP();
					}),
					{
						maximumAge: 0,
						enableHighAccuracy: false,
						timeout: 5000
					}
				);
			}
			else {
				this.locateIP();
			}
		},

		locateIP() {
			this.gettingLocation = true;

			$.ajax({
				url: 'https://www.googleapis.com/geolocation/v1/geolocate?key='+servicefinder.apiKey,
				data: JSON.stringify({ "considerIp": "true" }),
				type: 'POST',
				contentType: 'application/json',
				success: ((data) => {
					if (data.location) {
						this.getGeocodedAddress(data.location.lat, data.location.lng);
					}
					else {
						this.initMap();
						this.navigateToLocation(43.6532, -79.3832, 'Toronto, ON', 10);
						this.gettingLocation = false;
					}
				}),
				error: ((xhr, ajaxOptions, err) => {
					this.initMap();
										
					this.navigateToLocation(43.6532, -79.3832, 'Toronto, ON', 10);

					this.gettingLocation = false;
				})
			});
		},

		getGeocodedAddress(lat, lng) {
			let address = '';

			if (lat && lng) {
				this.maps.geocoder.geocode({'location': {lat: lat, lng: lng}}, ((results, status) => {
					if (status == 'OK') {
						let city = ''; let province = '';

	                    results[0].address_components.some((component) => {
	                    	if (component.types.indexOf('locality') >= 0) {
	                    		city = `${component.long_name}, `;
	                    	}
	                    	else if (component.types.indexOf('administrative_area_level_1') >= 0) {
	                    		province = component.long_name;
	                    	}
	                    	else if (component.types.indexOf('county') >= 0) {
	                    		province = component.long_name
	                    	}

	                    	if (city.length && province.length) {
	                    		return;
	                    	}
	                    });

	                    address = city+province;
					}

					this.gettingLocation = false;

					this.navigateToLocation(lat, lng, address, 10);
					this.initMap();
					this.getservices();
				}));
			}
		},

		geocodeLocation() {
			if (this.maps.location && this.maps.location.lat && this.maps.location.lng) {
				this.maps.geocoder.geocode({'location': this.maps.location}, ((results, status) => {
	                if (status == 'OK') {
	                    let city = ''; let province = '';

	                    results[0].address_components.some((component) => {
	                    	if (component.types.indexOf('locality') >= 0) {
	                    		city = `${component.long_name}, `;
	                    	}
	                    	else if (component.types.indexOf('administrative_area_level_1') >= 0) {
	                    		province = component.long_name;
	                    	}
	                    	else if (component.types.indexOf('county') >= 0) {
	                    		province = component.long_name
	                    	}

	                    	if (city.length && province.length) {
	                    		return;
	                    	}
	                    });

	                    this.maps.address = city+province;
	                }
	            }));
			}
			else {
				this.maps.address = '';
			}
		},

		navigateToLocation(lat, lng, address = '', zoom = '') {
			//See if the values are different than current
			if (this.query.lat == lat && this.query.lng == lng) return;
			
			let query = {
				lat: Number.parseFloat(lat).toFixed(5),
				lng: Number.parseFloat(lng).toFixed(5)
			};

			if (address) {
				query.address = address;
			}

			//Set the zoom level
			if (zoom) {
				query.z = zoom;
			}
			else if (this.maps.map) {
				query.z = this.maps.map.getZoom();
			}
			else {
				query.z = this.maps.location ? 10 : 4;
			}

			this.handleQuery(query);
			this.initMap();
			this.getservices();
		},

		handleQuery(to) {
			//Location
			if (to.lng && to.lat) {
				Vue.set(this.maps, 'location', {lng: parseFloat(to.lng), lat: parseFloat(to.lat)});
			}
			else {
				Vue.set(this.maps, 'location', null);
			}

			//Address
			if (to.address) {
				this.maps.address = to.address;
			}
		},

		loadPage(page) {
			if (page) {
				Vue.set(this.query, 'paged', page);
			}
			else {
				Vue.set(this.query, 'paged', 1);
			}
		},

		/**
		 * After changing pages especially, but whenever a new set of results loads
		 * If you are scrolled lower than the top of the results, scroll back up to it
		 */
		scrollUp() {
			$('#map-wrap').animate({ scrollTop: 0 }, 300);
		},

		/**
		 * Allow google autocomplete to submit by pressing enter
		 *
		 * @see https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter/11703018#11703018
		 */
		pacSelectFirst(input) {
			// service the original event binding function
	        var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

	        function addEventListenerWrapper(type, listener) {
	            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
	            // and then trigger the original listener.
	            if (type == "keydown") {
	                var orig_listener = listener;
	                listener = function(event) {
	                    var suggestion_selected = $(".pac-item-selected").length > 0;
	                    if (event.which == 13 && !suggestion_selected) {
	                        var simulated_downarrow = $.Event("keydown", {
	                            keyCode: 40,
	                            which: 40
	                        });
	                        orig_listener.apply(input, [simulated_downarrow]);
	                    }

	                    orig_listener.apply(input, [event]);
	                };
	            }

	            _addEventListener.apply(input, [type, listener]);
	        }

	        input.addEventListener = addEventListenerWrapper;
	        input.attachEvent = addEventListenerWrapper;
		},

		showInfoWindow(marker) {
			//Update infowindow text
			this.setInfowindowContent(marker.refersTo);

			//Open infowindow
			this.maps.infowindow.open(this.maps.map, marker);
			
		},

		setInfowindowContent(place) {
			if (!place || !place.meta) return;
			let content = '<div class="infowindow-content">';

			//Heading Title
			content += "<h3 class=\"has-h-4-font-size\" style=\"margin-bottom: var(--wp--preset--spacing--30);\"><strong>".concat(place.title, "</strong></h4>");
			
			//Address
			content += "<p class=\"has-small-font-size\" style=\"margin-top: var(--wp--preset--spacing--10); margin-bottom: var(--wp--preset--spacing--10);\">".concat(place.meta.street_address, "</p>");

			//Site URL
			var siteUrl = place.meta.site_url;
			if (!/^https?:\/\//i.test(siteUrl) || !/^http?:\/\//i.test(siteUrl)) {
				siteUrl = 'https://' + siteUrl;
			}
			content += '<p style="margin-bottom: 0;"><a target="_blank" href="' + siteUrl + '" class="has-small-font-size" style="margin-top: var(--wp--preset--spacing--10); margin-bottom: var(--wp--preset--spacing--10);padding-right: var(--wp--preset--spacing--40)">' + siteUrl + '</a></p>';
			
			//Secondary Site URL
			var secondarySiteUrl = place.meta.secondary_site_url;
			if (secondarySiteUrl) {
				// Ensure it starts with http or https
				if (!/^https?:\/\//i.test(secondarySiteUrl)) {
					secondarySiteUrl = 'https://' + secondarySiteUrl;
				}

				content +=
					'<p style="margin-top: 0;"><a target="_blank" href="' + secondarySiteUrl + '" class="has-small-font-size" style="margin-top: var(--wp--preset--spacing--10); margin-bottom: var(--wp--preset--spacing--10); padding-right: var(--wp--preset--spacing--40);">' +
					secondarySiteUrl +
					'</a></p>';
			}

			//That's all
			content += '</div>';

			this.maps.infowindow.setContent(content);
		},
	}
};
